import { createAction, props } from '@ngrx/store';

import { AnalyticsModuleName } from '../GA4/models/analytics-functionallity.models';

export const GeneralAnalyticsActionTypes = {
    LOAD_ANALYTICS_MODULE: '[Analytics Feature] LOAD_ANALYTICS_MODULE',
};

export const LoadAnalyticsModule = createAction(
    GeneralAnalyticsActionTypes.LOAD_ANALYTICS_MODULE,
    props<{ moduleName: AnalyticsModuleName }>()
);
